/* Intelligems x CheckoutChamp order attribution, shared by every CheckoutChamp redirect.
 * (docs.intelligems.io/integrations/other-integrations/checkout-champ-integration)
 *
 * Shoppers skip the Shopify cart and go straight to CheckoutChamp (get.nuflos.com), so the
 * attributes apps write to the Shopify cart (Intelligems igId / igTestGroups / igPreview,
 * fbp, ttp, vid, auid, UTMs, ...) never reach the order on their own. Before leaving for
 * CheckoutChamp, every cart attribute is added to the URL as cc_custom_<name>. CheckoutChamp
 * stores cc_custom_* params on the order and its Shopify sync writes them back as order
 * attributes, which Intelligems uses to credit the order to the visitor's test groups.
 *
 * Usage: theme redirects call window.ccGo(url) instead of window.location.href = url.
 * Plain <a href="https://get.nuflos.com/..."> links are handled automatically below.
 */
(function () {
  var CC_HOSTS = ['get.nuflos.com'];
  // Cap on the /cart.js lookup so a slow response never holds up checkout
  var CART_ATTRIBUTES_TIMEOUT = 1500;

  function isCheckoutChamp(url) {
    try {
      return CC_HOSTS.indexOf(new URL(url, window.location.href).hostname) !== -1;
    } catch (e) {
      return false;
    }
  }

  /* Landers send Add To Cart straight to CheckoutChamp, so the attributes are loaded ahead of
   * the click and the redirect never waits on the network. They are refreshed whenever an app
   * may have just written them: page load, Intelligems ready (it writes igId / igTestGroups /
   * igPreview right after), and when the tab comes back into view. */
  var cachedAttributes = null;
  var pendingLoad = null;

  function loadCartAttributes() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    pendingLoad = fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) { cachedAttributes = (cart && cart.attributes) || {}; })
      .catch(function () {});
    return pendingLoad;
  }

  function applyAttributes(dest, attributes) {
    Object.keys(attributes || {}).forEach(function (key) {
      var value = attributes[key];
      if (value === null || value === undefined || value === '') return;
      dest.searchParams.set('cc_custom_' + key, typeof value === 'string' ? value : JSON.stringify(value));
    });
  }

  function addCartAttributes(dest) {
    // Normal case: already loaded, nothing to wait for
    if (cachedAttributes) {
      applyAttributes(dest, cachedAttributes);
      return Promise.resolve();
    }
    // Clicked before the first load finished: wait for it, capped
    var load = (pendingLoad || loadCartAttributes()).then(function () { applyAttributes(dest, cachedAttributes); });
    var timeout = new Promise(function (resolve) { setTimeout(resolve, CART_ATTRIBUTES_TIMEOUT); });
    return Promise.race([load, timeout]);
  }

  loadCartAttributes();
  window.addEventListener('ig:ready', function () { setTimeout(loadCartAttributes, 300); });
  window.addEventListener('load', loadCartAttributes);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') loadCartAttributes();
  });

  // Intelligems' own cart copies (added above) win. This only fills in what is missing,
  // e.g. when /cart.js was too slow: igTestGroups = last UUID segment of each assigned group.
  function addIntelligems(dest) {
    try {
      var user = window.igData && window.igData.user;
      if (!user) return;
      if (dest.searchParams.has('cc_custom_igId') && dest.searchParams.has('cc_custom_igTestGroups')) return;
      if (user.igId) dest.searchParams.set('cc_custom_igId', user.igId);
      var experiments = (user.getExperiments && user.getExperiments()) || [];
      var groups = [];
      var inPreview = false;
      experiments.forEach(function (exp) {
        if (exp.isPreview) inPreview = true;
        var group = user.getTestGroup(exp.id);
        if (group && group.id) groups.push(group.id.split('-').pop());
      });
      if (groups.length) dest.searchParams.set('cc_custom_igTestGroups', groups.join(','));
      dest.searchParams.set('cc_custom_igPreview', String(inPreview));
    } catch (e) {}
  }

  // Returns a Promise of the CheckoutChamp URL with every cart attribute attached
  window.ccDecorateUrl = function (url) {
    var dest = new URL(url, window.location.href);
    return addCartAttributes(dest).then(function () {
      addIntelligems(dest);
      return dest.toString();
    });
  };

  window.ccGo = function (url) {
    if (!isCheckoutChamp(url)) {
      window.location.href = url;
      return;
    }
    window.ccDecorateUrl(url).then(
      function (decorated) { window.location.href = decorated; },
      function () { window.location.href = url; }
    );
  };

  // Plain links to CheckoutChamp. Links the theme already handles (preventDefault) are skipped,
  // since those handlers call ccGo themselves.
  document.addEventListener('click', function (evt) {
    if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
    var link = evt.target.closest && evt.target.closest('a[href]');
    if (!link || link.target === '_blank' || !isCheckoutChamp(link.href)) return;
    evt.preventDefault();
    window.ccGo(link.href);
  });
})();
